import numeral from 'numeral';
import * as langDeCh from './NumberFormatterLocales/de-ch';

const DEFAULT_LANGUAGE = 'de-ch';
numeral.register('locale', 'de-ch', langDeCh.language);

function getLocalizedNumeral(n: number): numeral.Numeral {
    numeral.locale(DEFAULT_LANGUAGE);
    return numeral(n);
}

/**
 * format a currency amount in cents/rappen to a localized string
 * @param locale
 * @param cents
 * @param currency
 * @returns {string}
 */
export function currencyCentsToLocalPrice(
    cents: number,
    currency = true,
    showDecimals = true,
): string {
    const value = cents / 100; // convert to chf
    const corrected = value >= 0.005 || value <= -0.005 ? value : 0;
    const str = getLocalizedNumeral(corrected).format(
        showDecimals ? '0,0.00' : '0,0',
    );

    return currency ? 'CHF\u00a0' + str : str;
}

export function numberToLocalPrice(n: number, currency = true): string {
    const corrected = n >= 0.005 || n <= -0.005 ? n : 0;
    const str = getLocalizedNumeral(corrected).format('0,0.00');

    return currency ? 'CHF\u00a0' + str : str;
}

export function numberToPrice(n: number, currency = true): string {
    return numberToLocalPrice(n, currency);
}

export function pad(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) {
        s = '0' + s;
    }
    return s;
}

export function format(n: number, formatString?: string): string {
    return getLocalizedNumeral(n).format(formatString);
}

export const leftPadZeroIfNotTwoDigits = (n: number): string => {
    if (n < 10) {
        return `0${Math.max(n, 0)}`;
    } else {
        return n.toString();
    }
};
